import { authTypes } from 'ducks/auth/types'
import { PropertyActivityType, PropertyActivityActions, propertyActivityType } from './types'

const initialState: PropertyActivityType = {} as PropertyActivityType

const reducer = (state = initialState, action: PropertyActivityActions): PropertyActivityType => {
  const { type, payload } = action

  switch (type) {
    case authTypes.LOGIN_REQUEST: { return initialState }
    case authTypes.LOGOUT_REQUEST: { return initialState }

    case propertyActivityType.SET_PROPERTY_ACTIVITIES: {
      return payload as PropertyActivityType
    }

    default:
      return state
  }
}

export default reducer
